import { looksLikeHttpOrDataUrlString } from "./linkInBioTheme";

/**
 * Extract short description from Finitless business API for Link in Bio tagline.
 * Skips values that look like URLs (API often stores image URLs in `header`).
 * @param {Record<string, unknown>|null|undefined} business
 * @returns {string}
 */
export function getBusinessTaglineForLinkInBio(business) {
  if (!business || typeof business !== "object") {
    return "";
  }
  const h = business.header;
  if (typeof h === "string" && h.trim() && !looksLikeHttpOrDataUrlString(h)) {
    return h.trim();
  }
  if (h && typeof h === "object") {
    if (
      typeof h.text === "string" &&
      h.text.trim() &&
      !looksLikeHttpOrDataUrlString(h.text)
    ) {
      return h.text.trim();
    }
    if (
      typeof h.description === "string" &&
      h.description.trim() &&
      !looksLikeHttpOrDataUrlString(h.description)
    ) {
      return h.description.trim();
    }
  }
  if (
    typeof business.description === "string" &&
    business.description.trim() &&
    !looksLikeHttpOrDataUrlString(business.description)
  ) {
    return business.description.trim();
  }
  return "";
}

/**
 * Map a business row (list/detail API) to Link in Bio restaurant fields.
 * @param {Record<string, unknown>|null|undefined} business
 * @returns {{ display_name: string, logo_url: string, tagline: string }}
 */
export function getRestaurantFieldsFromBusiness(business) {
  if (!business || typeof business !== "object") {
    return { display_name: "", logo_url: "", tagline: "" };
  }
  const name = business.name != null ? String(business.name).trim() : "";
  const logo =
    business.logo != null && String(business.logo).trim() !== ""
      ? String(business.logo).trim()
      : "";
  return {
    display_name: name,
    logo_url: logo,
    tagline: getBusinessTaglineForLinkInBio(business),
  };
}
